import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SituacaoCobrancas from '../components/SituacaoCobrancas';
import './Pagamentos.css';

export default function Pagamentos() {
  const navigate = useNavigate();
  const [activeSource, setActiveSource] = useState('asaas');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const handleClientesCardClick = (statusKey, startDate, endDate, source) => {
    setActiveSource(source);
    setStartDate(startDate);
    setEndDate(endDate);
    
    let situacao = '';
    switch (statusKey) {
      case 'RECEIVED': situacao = 'ADIMPLENTE'; break;
      case 'PENDING':  situacao = 'PENDENTE'; break;
      case 'OVERDUE':  situacao = 'INADIMPLENTE'; break;
      default: return;
    }
    let url = `/clients?tab=${source}&situacao=${situacao}`;
    if (startDate) url += `&startDate=${startDate}`;
    if (endDate) url += `&endDate=${endDate}`;
    navigate(url);
  };

  const handleCobrancasCardClick = (statusKey, startDate, endDate, source) => {
    setActiveSource(source);
    setStartDate(startDate);
    setEndDate(endDate);
    
    let url = `/cobrancas?status=${statusKey}&source=${source}`;
    if (startDate) url += `&startDate=${startDate}`;
    if (endDate) url += `&endDate=${endDate}`;
    navigate(url);
  };

  return (
    <div className="pagamentos-page">
      <div className="page-header">
        <div>
          <h1>Ver Pagamentos</h1>
          <p className="page-subtitle">Status real dos clientes via CPFL, Asaas e Pix</p>
        </div>
      </div>

      <div className="pagamentos-container">
        <SituacaoCobrancas
          onClientesClick={handleClientesCardClick}
          onCobrancasClick={handleCobrancasCardClick}
        />
      </div>
    </div>
  );
}